import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail'
})
export class MaskEmailPipe implements PipeTransform {
  transform(email: string): string {
    if (!email || typeof email !== 'string') return '';

    const [user, domain] = email.split('@');
    if (!user || !domain) return email;

    // Mascara usuario: deja los 3 primeros caracteres, el resto *
    const maskedUser = user.length > 3
      ? user.substring(0, 3) + '*'.repeat(user.length - 3)
      : user + '*'.repeat(Math.max(0, 3 - user.length));

    // Mascara dominio: deja la primera letra, luego * hasta el punto, luego el resto
    const domainParts = domain.split('.');
    const domainName = domainParts[0];
    const domainExt = domainParts.slice(1).join('.');

    const maskedDomain = domainName.length > 1
      ? domainName[0] + '*'.repeat(domainName.length - 1)
      : domainName;

    return `${maskedUser}@${maskedDomain}.${domainExt}`;
  }
}